/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Account_PcInputs */

const en_pc_cmp_r_account_pc = /** @type {(inputs: Pc_Cmp_R_Account_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None needed, no telemetry`)
};

const zh_pc_cmp_r_account_pc = /** @type {(inputs: Pc_Cmp_R_Account_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需账号，无遥测`)
};

/**
* | output |
* | --- |
* | "None needed, no telemetry" |
*
* @param {Pc_Cmp_R_Account_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_account_pc = /** @type {((inputs?: Pc_Cmp_R_Account_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Account_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_account_pc(inputs)
	return zh_pc_cmp_r_account_pc(inputs)
});
export { pc_cmp_r_account_pc as "pc.cmp.r.account.pc" }